// Which external-link fields an order shows, based on its website.
//   billUrl (bill/invoice link): Rakuten only.
//   transactionPageUrl (transaction page): every website EXCEPT Mercari,
//   Yahoo Auction, PayPay (so Mercari Shop uses transactionPageUrl, not billUrl).
// Shared by the create form (OrderForm) and the edit view (OrderDetail) so both
// gate these fields identically.
export const BILL_URL_WEBSITES = ['Rakuten'];
export const TXN_URL_HIDDEN_WEBSITES = ['Mercari', 'Yahoo Auction', 'PayPay'];

export const showsBillUrl = (website) => BILL_URL_WEBSITES.includes(website);
export const showsTransactionUrl = (website) =>
  !!website && !TXN_URL_HIDDEN_WEBSITES.includes(website);
